import { render, staticRenderFns } from "./HolidaySettingsForm.vue?vue&type=template&id=0fc72f0a&scoped=true&"
import script from "./HolidaySettingsForm.vue?vue&type=script&lang=js&"
export * from "./HolidaySettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc72f0a",
  null
  
)

export default component.exports